import { render, staticRenderFns } from "./fight.vue?vue&type=template&id=79e442bc&scoped=true"
import script from "./fight.vue?vue&type=script&lang=js"
export * from "./fight.vue?vue&type=script&lang=js"
import style0 from "./fight.vue?vue&type=style&index=0&id=79e442bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e442bc",
  null
  
)

export default component.exports